import { useMemo } from 'react'

const useInitialValue = <ValType>(getInitialValue: () => ValType) => useMemo(getInitialValue, [])

export default useInitialValue
